import { useState } from 'react'

export const useClientStatus = () => {
  const isClientActive = (status: string) =>
    status === 'Attivo' || status === 'Prospect'

  const getBlockedFeatures = (status: string) => {
    if (isClientActive(status)) return []
    return [
      'Invio automatico email',
      'Notifiche scadenze',
      'Generazione automatica fatture',
      'Accesso area riservata',
    ]
  }

  return { isClientActive, getBlockedFeatures }
}
